// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2YmD6","box":"WorkspacesBox_box__oe2Xn","node":"WorkspacesBox_node__fF6L_"};